import { useEffect, useState } from 'react';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import Snackbar from '@mui/material/Snackbar';
import useOnlineStatus from '../utils/useOnlineStatus';
import NewExpensesMobileInputs from './new-expenses-mobile/new-expenses-mobile-inputs';
import { saveExpenses, getSavedExpenses } from '../utils/offline-storage';

const OfflineExpenses = ({data}) => {
  const isOnline = useOnlineStatus();
  const [pendingExpenses, setPendingExpenses] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    getSavedExpenses((expenses) => {
      setPendingExpenses(expenses);
    }, (error) => {
      setErrorMessage(`${data.t.read('offline.error_loading')}${error ? `: ${error}` : ''}`);
    });
  }, []);

  const saveExpensesOffline = (expenses) => {
    setPendingExpenses((prevExpenses) => [...prevExpenses, ...expenses]);
    
    saveExpenses(expenses, (error) => {
      setErrorMessage(`${data.t.read('offline.error_saving')}${error ? `: ${error}` : ''}`);
    });
  };

  return (
    <div className="offline-expenses d-flex flex-column vh-100 pb-3">
      <div data-testid="offline-banner" className="bg-primary text-center p-2 text-white">
        <WifiOffIcon fontSize="large" classes={{ root: "d-block mx-auto" }} />
        {data.t.read('offline.banner')}
      </div>
      { isOnline && <div data-testid="online-message" className="bg-secondary text-center p-2 text-white">
        {data.t.read('offline.back_online')}
      </div> }

      { pendingExpenses.length > 0 ? (
        <div className="mt-3 mx-3 flex-shrink-1 overflow-auto">
          <p>
            {pendingExpenses.length} {pendingExpenses.length > 1 ? data.t.read('offline.pending_expenses') : data.t.read('offline.pending_expense')}
          </p>
          <ul className="mb-0">
            {pendingExpenses.map((expense, index) => (
              <li key={index} className="pending-expense" data-testid="pending-expense">
                {expense.description}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-center mt-3" data-testid="no-pending-expenses">
          {data.t.read('offline.no_pending_expenses')}
        </p>
      )}

      <NewExpensesMobileInputs data={data} offlineVersion={true} saveExpenses={saveExpensesOffline}/>

      <Snackbar
        open={errorMessage !== null}
        autoHideDuration={5000}
        onClose={() => setErrorMessage(null)}
        message={errorMessage}
        ContentProps={{ classes: { root: "error-snackbar" } }}
      />
    </div>
  );
};

export default OfflineExpenses;
